import { IApiError } from "@/interface/apiError.types";
import { parseApiError } from "@/lib/error-parser";
import { TranslationData } from "@/interface/translation.types";
import axios from "axios";
import { API_CONFIG } from "@/config";

export const fetchTranslations = async (): Promise<TranslationData> => {
  try {

    if (process.env.NEXT_PUBLIC_NODE_ENV !== "production") {
      return {};
    }

    const cmsAPIUrl = API_CONFIG.cmsApiUrl;

    const res = await axios.get(
      `${cmsAPIUrl}/languages/sync-translation/backend`,
      {
        headers: {
          "api-key": API_CONFIG.cmsApiKey,
        },
      }
    );
    return res?.data?.data;
  } catch (error) {
    await parseApiError(error as IApiError);
    throw error;
  }
};
